var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('notifications',{attrs:{"group":"foo"}}),_c('v-overlay',{attrs:{"z-index":"9999","value":_vm.globalLoading}},[_c('span',[_vm._v("cargando")]),_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary darken-2"}})],1),(_vm.flagLoggedIn)?_c('mainmenuappbar'):_vm._e(),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }